export enum LocationType {
  None = 'None',
  ValidOneOff = 'ValidOneOff',
  InvalidOneOff = 'InvalidOneOff',
  ValidSaved = 'ValidSaved',
  InvalidSaved = 'InvalidSaved'
}
